export default "__VITE_ASSET__9339669e__"